'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var VacuumCleaner = function (_React$Component) {
    _inherits(VacuumCleaner, _React$Component);

    function VacuumCleaner() {
        _classCallCheck(this, VacuumCleaner);

        return _possibleConstructorReturn(this, (VacuumCleaner.__proto__ || Object.getPrototypeOf(VacuumCleaner)).apply(this, arguments));
    }

    _createClass(VacuumCleaner, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M22.135 24.301h-2.075v-16.361c0-2.421-1.97-4.391-4.391-4.391-1.533 0-2.929 0.778-3.735 2.082s-0.878 2.901-0.192 4.272c1.244 2.488 1.362 5.368 0.342 7.945-1.91-0.761-4.046-1.157-5.858-1.157-2.973 0-5.398 2.358-5.522 5.3-0.444 0.661-0.704 1.455-0.704 2.309 0 2.288 1.862 4.15 4.15 4.15 0.846 0 1.633-0.256 2.289-0.692h5.853c0.38 0.423 0.93 0.692 1.543 0.692 1.026 0 1.878-0.749 2.044-1.729 0.865-0.761 1.415-1.873 1.415-3.113 0-2.264-1.692-4.013-3.95-5.186 1.194-2.96 1.067-6.276-0.364-9.139-0.47-0.939-0.42-2.033 0.132-2.926s1.508-1.426 2.558-1.426c1.659 0 3.007 1.349 3.007 3.007v19.82c0 0.382 0.31 0.692 0.692 0.692h5.534c0.382 0 0.692-0.31 0.692-0.692 0-1.907-1.551-3.459-3.459-3.459zM4.15 27.068c-1.526 0-2.767-1.241-2.767-2.767s1.241-2.767 2.767-2.767 2.767 1.241 2.767 2.767-1.241 2.767-2.767 2.767zM15.825 22.917c0.054 0.225 0.085 0.455 0.085 0.692 0 1.526-1.241 2.767-2.767 2.767h-5.404c0.355-0.611 0.562-1.319 0.562-2.075 0-2.288-1.862-4.15-4.15-4.15-0.608 0-1.184 0.135-1.705 0.37 0.652-1.44 2.099-2.446 3.78-2.446 0.387 0 0.791 0.021 1.205 0.062l1.15 2.684c0.546 1.274 1.794 2.096 3.179 2.096h4.065zM15.129 21.534h-3.37c-0.831 0-1.58-0.494-1.908-1.258l-0.81-1.891c2.42 0.505 4.874 1.608 6.088 3.149zM20.060 27.068v-1.383h2.075c0.902 0 1.671 0.578 1.957 1.383h-4.032z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M4.15 22.917c-0.763 0-1.383 0.621-1.383 1.383s0.621 1.383 1.383 1.383 1.383-0.621 1.383-1.383-0.621-1.383-1.383-1.383z' })
            );
        }
    }]);

    return VacuumCleaner;
}(_react2.default.Component);

VacuumCleaner.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = VacuumCleaner;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/vacuum-cleaner.js
// module id = 1130
// module chunks = 0